
export const BASE_URL = process.env.REACT_APP_API_LINK;
export const CLIENT_BASE_URL = BASE_URL+'/client-application';

export const USER = `${CLIENT_BASE_URL}/me`;
